module.exports = __webpack_public_path__ + "static/media/marionAbbott58.25190e04.png";